import { useEffect, useState } from 'react'
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, IconButton, Alert, } from '@mui/material'
import { CloseOutlined } from '@ant-design/icons'

import { useEventBusContext } from 'services/provider/EventBusProvider'
import { stockUnitUpdate, stockUnitDetail } from 'models/stockUnit'
import { EVENT_STOCKUNIT_UPDATE_INIT, EVENT_STOCKUNIT_UPDATE_SUCCESS, } from 'models/events/stockUnit.event'
import StockUnitForm from './StockUnit.Form'


export const StockUnitEditDialog = () => {
    const eventbus = useEventBusContext()
    const [open, setOpen] = useState(false)
    const [unitId, setUnitId] = useState(null)
    const [values, setValues] = useState({})
    const [errors, setErrors] = useState({})
    const [saving, setSaving] = useState(false)
    const [generalError, setGeneralError] = useState(null)

    useEffect(() => {
        return eventbus.on(EVENT_STOCKUNIT_UPDATE_INIT, async (item) => {
            const id = typeof item === 'object' ? item.id : item;

            setUnitId(id);
            setErrors({});
            setGeneralError(null);

            try {
                const res = await stockUnitDetail(id);
                const unit = res.data || res;

                setValues({
                    name: unit.name || '',
                });

                setOpen(true);
            } catch (err) {
                console.error(err);
            }
        });
    }, [eventbus]);

    const handleChange = (field, value) => {
        setValues((prev) => ({ ...prev, [field]: value }))
        setErrors((prev) => ({ ...prev, [field]: undefined }))
    }

    const validate = () => {
        const next = {};

        if (!values.name?.trim()) {
            next.name = 'Name is required.';
        }

        setErrors(next);

        return Object.keys(next).length === 0;
    };

    const extractFieldErrors = (err) => err?.response?.data?.errors || err?.errors || {}

    const handleSubmit = async () => {
        if (!unitId || !validate()) return

        setSaving(true)
        setGeneralError(null)
        try {
            await stockUnitUpdate(unitId, {
                name: values.name.trim(),
            });
            eventbus.fire(EVENT_STOCKUNIT_UPDATE_SUCCESS)
            setOpen(false)
        } catch (err) {
            const fieldErrors = extractFieldErrors(err)
            if (Object.keys(fieldErrors).length > 0) {
                setErrors(fieldErrors)
            } else {
                setGeneralError(err?.response?.data?.message || err?.message || 'Failed to update stock unit.')
            }
        } finally {
            setSaving(false)
        }
    }

    return (
        <Dialog open={open} onClose={() => !saving && setOpen(false)} maxWidth="sm" fullWidth>
            <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                Edit Stock Unit
                <IconButton onClick={() => !saving && setOpen(false)} size="small">
                    <CloseOutlined />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers>
                {generalError && (
                    <Alert severity="error" sx={{ mb: 2 }}>
                        {generalError}
                    </Alert>
                )}
                <StockUnitForm values={values} errors={errors} onChange={handleChange} disabled={saving} />
            </DialogContent>
            <DialogActions sx={{ p: 2 }}>
                <Button onClick={() => setOpen(false)} disabled={saving}>
                    Cancel
                </Button>
                <Button variant="contained" onClick={handleSubmit} disabled={saving}>
                    {saving ? 'Saving\u2026' : 'Save Changes'}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default StockUnitEditDialog